import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import JSEncrypt from "jsencrypt";
import { generateHash } from "../service";
import { loginAPI } from "../service/AuthService";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { PUBLIC_KEY } from "../utils/constants";
import { Helmet } from "react-helmet";
import LoginPopUp from "../components/LoginPopUp";

export default function Login() {
  const dispatch = useDispatch();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isAutoLogin, setIsAutoLogin] = useState(false);

  useEffect(() => {
    const autoLoginFlag = localStorage.getItem("autoLoginFlag");
    if (autoLoginFlag) {
      const flagValue = parseInt(autoLoginFlag);
      if (flagValue > 1) {
        setIsAutoLogin(true);
        localStorage.removeItem("autoLoginFlag");
      } else if (flagValue === 1) {
        setIsAutoLogin(true);
        localStorage.setItem("autoLoginFlag", "2");
      }
    }
  }, []);

  const login = async (userName, password, isDemo = false) => {
    setLoading(true);
    let encryptedPassword = new JSEncrypt();
    encryptedPassword.setPublicKey(PUBLIC_KEY);
    encryptedPassword = encryptedPassword.encrypt(password);
    setLoading(true);
    let fingerprint = await generateHash();
    localStorage.setItem("fingerprint", fingerprint);
    var { data, code, message, response, error } = await loginAPI(
      userName,
      encryptedPassword,
      isDemo
    );

    if (code == 200) {
      setLoading(false);
      const autoLoginFlag = localStorage.getItem("autoLoginFlag");
      const counter = sessionStorage.getItem("counter");
      if (counter == 1) {
        sessionStorage.removeItem("counter");
      } else {
        sessionStorage.setItem("counter", 1);
      }
      toast.success("Login Success");

      dispatch({
        type: "accountData/setUserData",
        payload: { ...response, isAutoLogin: true },
      });
      dispatch({
        type: "accountData/setLoginPopSate",
        payload: false,
      });
      dispatch({
        type: "accountData/setChangePopSate",
        payload: response.resetRequired,
      });
      window.location.href = "/";
      setTimeout(() => {
        window.location.reload();
      }, 200);
    } else if (code == 500) {
      toast.error(response);
      setLoading(false);
    } else if (code == 403) {
      toast.error(response?.description);
      setLoading(false);
    } else if (code == 401) {
      toast.error(response);
      setLoading(false);
    } else {
      toast.error("Something went wrong or Account is not active");
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <div style={{ marginTop: "-11%" }}>
      <LoginPopUp
        login={login}
        isAutoLogin={isAutoLogin}
        isLoading={loading}
        setLoading={setLoading}
      />
    </div>
  );
}
